<template>
  <div class="text-viewer">
    <div v-if="error" class="error">
      <span class="material-symbols-outlined">error</span>
      <span>{{ error }}</span>
    </div>
    <div v-else-if="loading" class="tv-loading">
      <span class="tv-spinner"></span>
      Yükleniyor...
    </div>
    <div v-else>
      <div class="pdf-controller">
        <div class="pdf-controller-inner">
          <button :title="[isWrapped ? 'Orijinali Gör' : 'Sayfaya Sığdır']" :aria-label="[isWrapped ? 'Orijinali Gör' : 'Sayfaya Sığdır']" class="tv-btn" @click="toggleWrap">
            <span v-if="!isWrapped" class="material-symbols-outlined">wrap_text</span>
            <span v-else class="material-symbols-outlined">format_align_left</span>
          </button>
        </div>
      </div>
      <div class="content-container" :class="{ 'nowrap': !isWrapped }">
        <pre :style="computedStyle">{{ content }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TextViewer',
  props: {
    url: {
      type: String,
      required: true
    },
    textStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      content: '',
      error: null,
      isWrapped: false,
      defaultStyle: {
        fontSize: '13px',
      },
      loading: false,
    }
  },
  computed: {
    computedStyle() {
      return {
        ...this.defaultStyle,
        ...this.textStyle,
        whiteSpace: this.isWrapped ? 'pre-wrap' : 'pre',
        wordWrap: this.isWrapped ? 'break-word' : 'normal'
      }
    }
  },
  watch: {
    url: {
      immediate: true,
      handler: 'fetchContent'
    }
  },
  methods: {
    async fetchContent() {
      try {
        this.loading = true;
        const response = await axios.get(this.url, {
          responseType: 'blob'
        })

        const reader = new FileReader()
        reader.onload = () => {
          this.content = reader.result
        }
        reader.readAsText(new Blob([response.data]))
        this.loading = false;
      } catch (err) {
        this.error =  'Doküman indirilirken bir hata oldu.'
        this.loading = false;
        console.error(err)
      }
    },
    toggleWrap() {
      this.isWrapped = !this.isWrapped
    }
  }
}
</script>

<style scoped>
/* Voya: metin görüntüleyici */
.text-viewer {
  box-sizing: border-box;
  margin-top: 56px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 12px calc(env(safe-area-inset-bottom, 0px) + 84px) 12px;
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
}

.content-container {
  flex-grow: 1;
  overflow: auto;
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid #EFEFEF;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
}

.content-container pre {
  margin: 0;
  color: #333333;
}

.content-container.nowrap {
  white-space: nowrap;
}

.error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background-color: #FDECEE;
  font-size: 13px;
  line-height: 150%;
  color: #B02A37;
}

.error .material-symbols-outlined {
  flex-shrink: 0;
  font-size: 20px;
}

.tv-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 100px 0;
  font-weight: 500;
  font-size: 13px;
  color: #808080;
}

.tv-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #FCE3CE;
  border-top-color: #F37615;
  border-radius: 50%;
  animation: tv-spin 0.8s linear infinite;
}

@keyframes tv-spin {
  to {
    transform: rotate(360deg);
  }
}

.pdf-controller{
  position: fixed;
  z-index: 999;
  display: flex;
  right: 12px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 20px);
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}

.pdf-controller-inner{
  display: flex;
  flex-direction: column;
  padding: 4px;
  align-items: center;
  border: 1px solid #EFEFEF;
  background-color: #ffffff;
  box-shadow: 0 4px 16px rgba(9, 33, 84, 0.2);
  border-radius: 100px;
  transition: all 0.2s ease-in-out;
}

.tv-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: transparent;
  color: #092154;
}

.tv-btn .material-symbols-outlined {
  font-size: 24px;
}

.tv-btn:active {
  background-color: #EEF1F5;
}
</style>
